<template>

    <div class="TQ_center TQ_bg_gray4 TQ_font_SecularOne" v-if="p_questReview_c">

        <!-- title -->
        <div class="TQ_text_28px TQ_padding_8px  TQ_text_bold TQ_borderRadius_top TQ_bg_purple">
            {{ass_strings.fourWords_howWasTheQuest[store_system_langCode_ve.val]}}
        </div>

        <div class="TQ_padding_8px">

            <!-- general review-->
            <div class="TQ_margin_top_8px">

                <div class="TQ_text_20px TQ_align_initial">
                    {{ass_strings.twoWords_overallRating[store_system_langCode_ve.val]}}
                </div>

                <div class="TQ_bg_white TQ_borderRadius TQ_box_shadow TQ_padding_8px TQ_direction_ltr" :class="!co_mobileSize_b ? 'TQ_grid_col_1frAuto TQ_initialAlign' : ''">
                    <div>
                        <si_-stars :pe_change-rating_f="(val) => {p_questReview_c.qr_overallRating_n = val}"
                                   :rating="p_questReview_c.qr_overallRating_n"
                                   class="TQ_grid_verticalCenter TQ_clickable TQ_inline TQ_grid_verticalCenter"
                                   p_stars-margin_s="2px"
                                   p_stars-width_s="32px" />
                    </div>


                    <div class="TQ_grid_verticalCenter TQ_text_20px TQ_textColor_purple TQ_text_bold"
                         :class="!co_mobileSize_b ? 'TQ_initialAlign' : ''">
                        {{p_questReview_c.qr_overallRating_n != null ? co_totalStars_ao[p_questReview_c.qr_overallRating_n-1].text_s : ""}}
                    </div>
                </div>

            </div>

            <!-- diff level-->
            <div class="TQ_margin_top_8px">

                <div class="TQ_text_20px TQ_align_initial">
                    {{ass_strings.twoWords_difficultyLevel[store_system_langCode_ve.val]}}
                </div>

                <div class="TQ_bg_white TQ_borderRadius TQ_box_shadow TQ_padding_8px TQ_direction_ltr" :class="!co_mobileSize_b ? 'TQ_grid_col_1frAuto' : ''">

                    <div class="TQ_grid_verticalCenter  " :class="!co_mobileSize_b ? 'TQ_initialAlign' : ''">

                        <div v-for="(item,index_n) in co_diffLevels_ao"
                             class="TQ_inline TQ_margin_4px TQ_clickable TQ_width_56px TQ_verticalAlignMiddle"
                             @mouseover="hoverDiffLevel_n = index_n+1"
                             @mouseleave="hoverDiffLevel_n = null"
                             @click="p_questReview_c.qr_difficulty_n = index_n+1">

                            <img class="TQ_verticalAlignMiddle"
                                 :src="hoverDiffLevel_n >= index_n+1 || p_questReview_c.qr_difficulty_n >= index_n+1 ? item.selectedImg_r : item.notSelectedImg_r"
                                 :class="p_questReview_c.qr_difficulty_n >= index_n+1 ? 'TQ_Animation_smallBigSmall_infinite' : ''"/>

                        </div>
                    </div>


                    <div :key="p_questReview_c.qr_difficulty_n" class="TQ_grid_verticalCenter TQ_text_20px  TQ_text_bold TQ_textColor_purple  TQ_animation_fadeIn"
                         :class="!co_mobileSize_b ? 'TQ_initialAlign' : ''">
                        {{p_questReview_c.qr_difficulty_n != null ? co_diffLevels_ao[p_questReview_c.qr_difficulty_n-1].text_s : ""}}
                    </div>

                </div>

            </div>

            <!-- public -->
            <div class="TQ_margin_top_16px">

                <div class="TQ_text_20px TQ_align_initial">
                    {{ass_strings.twoWords_publicFeedback[store_system_langCode_ve.val]}}
                </div>

                <tq-textarea
                    pb_textarea-class_s="TQ_text_16px TQ_box_shadow TQ_padding_8px TQ_borderRadius"
                    pb_uid_s="public"
                    :pb_init-text_s="p_questReview_c.qr_publicFeedback_s"
                    :pb_max-length_n="500"
                    :pb_placeholder_s="ass_strings.sentenceGroup_review1[store_system_langCode_ve.val]"
                    :pb_rows_n="2"
                    :pe_change-text_s="(text_s) => {p_questReview_c.qr_publicFeedback_s = text_s}"
                    :pf_autoresize_b="true"
                />
            </div>

            <!-- private -->
            <div class="lc_lastTextArea">
                <div class="TQ_text_20px TQ_align_initial">
                    {{ass_strings.twoWords_privateFeedback[store_system_langCode_ve.val]}}
                </div>
                <tq-textarea
                    pb_textarea-class_s="TQ_text_16px TQ_box_shadow TQ_padding_8px TQ_borderRadius"
                    pb_uid_s="private"
                    :pb_init-text_s="p_questReview_c.qr_privateFeedback_n"
                    :pb_max-length_n="500"
                    :pb_placeholder_s="ass_strings.sentenceGroup_review2[store_system_langCode_ve.val]"
                    :pb_rows_n="2"
                    :pe_change-text_s="(text_s) => {p_questReview_c.qr_privateFeedback_n = text_s}"
                    :pf_autoresize_b="true"
                />

            </div>

            <hr>

            <tq-btn-approve
                class="TQ_margin_4px "
                btn-class="TQ_bg_green TQ_text_20px TQ_borderRadius TQ_padding_8px TQ_box_shadow TQ_maxWidth_150px TQ_inline TQ_width_100p"
                :system-lang-code="store_system_langCode_ve.val"
                :text="ass_strings.oneWord_submit"
                :popup-text="ass_strings.question_submitReview"
                :approve-cb="() => {pe_submitReview_f() } ">
            </tq-btn-approve>

        </div>




    </div>

</template>

<script>

    import Si_Stars from "../a_smartIcons/si_Stars";
    import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {validator_enum_fb} from "../../../functions/src/shareCode/Share_S_Validator";
    import {enum_screenSizesOptions_n} from "../../../functions/src/shareCode/Share_S_Enum";
    import {store_getStateValue_vo, store_var} from "../../store";
    import {FB_QuestReview} from "../../../functions/src/shareCode/Share_S_Classes";
    import TqTextareaAutosize from "../basic/TqTextareaAutosize";
    import TqTextarea from "../basic/TqTextarea";
    import TqBtnApprove from "../basic2/TqBtnApprove";
    import {
        format_date_YYYY_MM_DD_fs,
    } from "../../../functions/src/shareCode/Share_S_Format";
    import {
        ass_img_diffLevel1_c,
        ass_img_diffLevel1_gray,
        ass_img_diffLevel2_c,
        ass_img_diffLevel2_gray,
        ass_img_diffLevel3_c,
        ass_img_diffLevel3_gray,
        ass_img_diffLevel4_c,
        ass_img_diffLevel4_gray,
        ass_img_diffLevel5_c, ass_img_diffLevel5_gray
    } from "../../assets/scripts/Ass_Files";
    import {FB_QuestEvent} from "../../../functions/src/shareCode/Share_S_Classes";

    export default {
        name: "v_Player_Tickets_Review",
        components: {TqBtnApprove, TqTextarea, TqTextareaAutosize, Si_Stars},
        props:{
            p_questEvent_c:{
                type : FB_QuestEvent,
                require: true
            },
            p_windowSizeType_e:{
                type : Number,
                require: true,
                validator(windowSize_e){
                    return validator_enum_fb(enum_screenSizesOptions_n, windowSize_e)
                }
            },
            p_questReview_c:{
                type : FB_QuestReview,
                require: true,
            },
            pe_submitReview_f:{
                type : Function,
                require: true,
            }
        },
        data(){
            return {

                questReview_c       : undefined,

                hoverDiffLevel_n    : null,

                // store
                store_system_langCode_ve : store_getStateValue_vo(store_var.system_langCode),

                // imports
                ass_strings : ass_strings,
                format_date_YYYY_MM_DD_fs : format_date_YYYY_MM_DD_fs,
            }
        },
        computed:{
            co_diffLevels_ao(){
                return [
                    {selectedImg_r : ass_img_diffLevel1_c, notSelectedImg_r : ass_img_diffLevel1_gray, text_s : ass_strings.twoWords_veryEasy[this.store_system_langCode_ve.val]},
                    {selectedImg_r : ass_img_diffLevel2_c, notSelectedImg_r : ass_img_diffLevel2_gray, text_s : ass_strings.oneWord_easy[this.store_system_langCode_ve.val]},
                    {selectedImg_r : ass_img_diffLevel3_c, notSelectedImg_r : ass_img_diffLevel3_gray, text_s : ass_strings.oneWord_medium[this.store_system_langCode_ve.val]},
                    {selectedImg_r : ass_img_diffLevel4_c, notSelectedImg_r : ass_img_diffLevel4_gray, text_s : ass_strings.oneWord_hard[this.store_system_langCode_ve.val]},
                    {selectedImg_r : ass_img_diffLevel5_c, notSelectedImg_r : ass_img_diffLevel5_gray, text_s : ass_strings.twoWords_veryHard[this.store_system_langCode_ve.val]},
                ]

            },
            co_totalStars_ao(){
                return [
                    {selectedImg_r : ass_img_diffLevel5_c, notSelectedImg_r : ass_img_diffLevel5_gray, text_s : ass_strings.twoWords_poor[this.store_system_langCode_ve.val]},
                    {selectedImg_r : ass_img_diffLevel4_c, notSelectedImg_r : ass_img_diffLevel4_gray, text_s : ass_strings.oneWord_fair[this.store_system_langCode_ve.val]},
                    {selectedImg_r : ass_img_diffLevel3_c, notSelectedImg_r : ass_img_diffLevel3_gray, text_s : ass_strings.oneWord_good[this.store_system_langCode_ve.val]},
                    {selectedImg_r : ass_img_diffLevel2_c, notSelectedImg_r : ass_img_diffLevel2_gray, text_s : ass_strings.twoWords_VeryGood[this.store_system_langCode_ve.val]},
                    {selectedImg_r : ass_img_diffLevel1_c, notSelectedImg_r : ass_img_diffLevel1_gray, text_s : ass_strings.oneWord_excellent[this.store_system_langCode_ve.val]},
                ]
            },
            co_mobileSize_b(){
                return this.p_windowSizeType_e === enum_screenSizesOptions_n.mobile
            }
        },

    }
</script>

<style scoped lang="scss">

    .lc_diffLevel{
        margin: -8px;
    }
    .lc_lastTextArea{
        margin-top: -16px;
    }
</style>